import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SurveyService {

  constructor() { }
  
  openSurveyDuringMaintenance(maintenanceStartTime:Date, maintenanceEndTime:Date ): boolean {
    // 獲取當前時間（台灣時間）
    const currentDate = new Date();
    const TWTimeOffset = 8 * 60; // 台灣時區偏移為 UTC+8 小時
    currentDate.setMinutes(currentDate.getMinutes() + currentDate.getTimezoneOffset() + TWTimeOffset);

    // 檢查當前時間是否在維護時間段內
    const isMaintenance = currentDate >= maintenanceStartTime && currentDate <= maintenanceEndTime;
    console.log("maintenanceStartTime:",maintenanceStartTime,currentDate >= maintenanceStartTime)
    console.log("maintenanceEndTime:",maintenanceEndTime,currentDate <= maintenanceEndTime)
    console.log("isMaintenance:",isMaintenance)
    return isMaintenance ;
  }
}
